import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { switchToLevel, preloadDemoImages } from "./helpers";

const welcome: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.welcomeIntro}
						<br />
						<br />
						{text.tourSteps.welcomeDescription}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			switchToLevel(1);
			preloadDemoImages();
		},
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.whyText}</strong>
						<br />
						<br />
						{text.tourSteps.whyTextResearch}
						<ul style={{ margin: "0.5em 0 0", paddingLeft: "1.2em", lineHeight: 1.6 }}>
							<li>{text.tourSteps.whyFast}</li>
							<li>{text.tourSteps.whyPrecise}</li>
							<li>{text.tourSteps.whyAccessible}</li>
							<li>{text.tourSteps.whyPowerful}</li>
						</ul>
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.designTitle}</strong>
						<br />
						<br />
						{text.tourSteps.designBody1}
						<br />
						<br />
						{text.tourSteps.designBody2}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-chat",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.chatTabIntro}
			/>
		),
	},
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.chatInputHint}
			/>
		),
		position: "right",
	},
	{
		selector: ".chat-codemirror",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.chatPasteNotes}
			/>
		),
		position: "right",
	},
];

export default welcome;
